export const segmentsProgress = {
  templateUrl: "admin/views/segments-progress.html",
  bindings: {
    label: "@",
    segments: "<",
    lengthInSeconds: "=",
  },
  //! @ngInject
  controller: function ($scope) {
    this.$onInit = function () {
      $scope.label = this.label;
      $scope.segments = this.segments;
      $scope.lengthInSeconds = this.lengthInSeconds;
    }
  }
};
